import { toThousandsFormat } from './toThousandsFormat'

interface FormatPriceOptions {
  decimals?: number // Количество знаков после запятой (по умолчанию 2)
  fallback?: string // Значение при ошибке (по умолчанию исходная строка)
  allowNegative?: boolean // Разрешить отрицательные числа (по умолчанию true)
  trimIfInteger?: boolean // Убирать дробную часть для целых чисел (по умолчанию false)
}

export const toPriceFormat = (value: string | number, options: FormatPriceOptions = {}): string => {
  const { decimals = 2, fallback = '', allowNegative = true, trimIfInteger = false } = options

  const num = typeof value === 'string' ? parseFloat(value) : value

  if (Number.isNaN(num)) {
    return fallback
  }

  if (!allowNegative && num < 0) {
    return fallback
  }

  if (trimIfInteger && Number.isInteger(num)) {
    return toThousandsFormat(num.toString().replace('.', ','))
  }

  return toThousandsFormat(num.toFixed(decimals).replace('.', ','))
}
